<!-- <ul class="header-dropdown-list ng-cloak" style="margin-top: -6px !important;" *ngIf="reload" (click)="showList($event)">
    <li class="dropdown" style="height: 49px; padding: 0px 12px;">
        <a class="dropdown-toggle" style="margin-top: 28px;">
            <img src="assets/img/flags/{{currentLanguage.key}}.svg" class="flag" alt="{{currentLanguage.alt}}" />
            <span style="font-size: 14px;" class="theme-header-text-color language-text">&nbsp;{{ currentLanguage.title | i18n}}&nbsp;</span>
            <i class="fa fa-angle-down" style="margin-left: 5px; font-weight: 400;"></i>
        </a>
        <ul class="dropdown-menu mt-2 language-list" #languageList>
            <li [class.active]="language == currentLanguage" *ngFor="let language of languages">
                <a (click)="setLanguage(language)" class="dropdown-item pl-2 mt-1"><img src="assets/img/flags/{{language.key}}.svg" class="flag" alt="{{language.alt}}" /> {{ language.title | i18n}}</a>
            </li>
        </ul>
    </li>
</ul> -->

<div class="btn-header lang-selector-btn">
    <ul class="header-dropdown-list ng-cloak" *ngIf="reload">
        <li class="dropdown" dropdown>
            <a class="dropdown-toggle" dropdownToggle>
                <img src="assets/img/blank.gif" class="flag flag-{{currentLanguage.key}}" alt="{{currentLanguage.alt}}">
                <span> {{currentLanguage.title | i18n}} </span>
                <i class="fa fa-angle-down"></i>
            </a>
            <ul *dropdownMenu class="dropdown-menu" #languageList>
                <li [class.active]="language.key==currentLanguage.key" *ngFor="let language of languages">
                    <a (click)="setLanguage(language)" class="dropdown-item">
                        <img src="assets/img/blank.gif" class="flag flag-{{language.key}}" alt="{{language.alt | i18n}}">
                        {{language.title | i18n}}
                    </a>
                </li>
            </ul>
        </li>
    </ul>
</div>
